(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    // Pagination for the carousel. Reads the real geometry of the slides rather
  // than the column setting, so the page count stays right at every breakpoint.
  if (!customElements.get('carousel-pagination')) {
    customElements.define(
      'carousel-pagination',
      class CarouselPagination extends HTMLElement {
        connectedCallback() {
          this.pageIndex = 0;
          this.onScroll = this.onScroll.bind(this);
          this.refresh = this.refresh.bind(this);
          this.ticking = false;

          // Slides may not be laid out yet on first connect.
          requestAnimationFrame(function () {
            this.setup();
          }.bind(this));
        }

        disconnectedCallback() {
          if (this.scroller) this.scroller.removeEventListener('scroll', this.onScroll);
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        setup() {
          var root = this.closest('slideshow-component') || this.closest('.force-full-width');
          if (!root) return;

          this.scroller = this.findScroller(root);
          if (!this.scroller) return;

          this.slides = Array.prototype.filter.call(this.scroller.children, function (el) {
            return el.offsetWidth > 0;
          });
          if (this.slides.length < 2) return;

          // Some slideshow implementations move slides with a transform instead
          // of scrolling; then the arrows are the only way to advance.
          this.usesScroll = this.scroller.scrollWidth - this.scroller.clientWidth > 4;
          if (this.usesScroll) {
            this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
          } else {
            this.prevControl = root.querySelector('.slideshow-control--prev');
            this.nextControl = root.querySelector('.slideshow-control--next');
            if (!this.nextControl) return;
            this.watchControls();
          }

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.refresh);
            this.resizeObserver.observe(this.scroller);
          } else {
            window.addEventListener('resize', this.refresh);
          }

          this.refresh();
        }

        // slideshow.liquid gives the scroll container ref="scroller"; fall back
        // to the tag, then to a child, in case that markup changes.
        findScroller(root) {
          var slides = root.querySelector('[ref="scroller"]') || root.querySelector('slideshow-slides');
          if (!slides) return null;
          var candidates = [slides].concat(Array.prototype.slice.call(slides.children));
          for (var i = 0; i < candidates.length; i++) {
            if (candidates[i].scrollWidth - candidates[i].clientWidth > 4) return candidates[i];
          }
          return slides;
        }

        step() {
          if (this.slides.length > 1) {
            var delta = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
            if (delta > 0) return delta;
          }
          return this.slides[0].offsetWidth || 1;
        }

        pageCount() {
          var step = this.step();
          var perView = Math.max(1, Math.round(this.scroller.clientWidth / step));
          return Math.max(1, this.slides.length - perView + 1);
        }

        refresh() {
          var pages = this.pageCount();

          // Nothing to page through once every slide fits on screen.
          if (pages < 2) {
            this.hidden = true;
            this.innerHTML = '';
            this.builtFor = null;
            return;
          }

          this.hidden = false;
          if (this.builtFor !== pages) this.build(pages);
          this.setActive(this.currentIndex(pages), pages);
        }

        build(pages) {
          this.builtFor = pages;
          this.innerHTML = '';
          this.setAttribute('role', 'group');
          this.setAttribute('aria-label', 'Carousel pagination');

          // Numbered buttons stop being readable past a handful of slides, so
          // long carousels get a compact counter instead.
          this.compact = this.dataset.style === 'numbers' && pages > 7;
          if (this.compact) {
            this.counter = document.createElement('span');
            this.counter.className = 'carousel-pagination__counter';
            this.counter.setAttribute('aria-live', 'polite');
            this.appendChild(this.counter);
            return;
          }

          for (var i = 0; i < pages; i++) {
            (function (index) {
              var button = document.createElement('button');
              button.type = 'button';
              button.setAttribute('aria-label', 'Go to slide ' + (index + 1));
              if (this.dataset.style === 'numbers') button.textContent = String(index + 1);
              button.addEventListener('click', function () {
                this.goTo(index);
              }.bind(this));
              this.appendChild(button);
            }.bind(this))(i);
          }
        }

        currentIndex(pages) {
          if (!this.usesScroll) return Math.min(this.pageIndex, pages - 1);
          return Math.min(pages - 1, Math.max(0, Math.round(this.scroller.scrollLeft / this.step())));
        }

        setActive(index, pages) {
          this.pageIndex = index;
          if (this.compact) {
            if (this.counter) this.counter.textContent = index + 1 + ' / ' + pages;
            return;
          }
          var buttons = this.children;
          for (var i = 0; i < buttons.length; i++) {
            if (i === index) {
              buttons[i].setAttribute('aria-current', 'true');
            } else {
              buttons[i].removeAttribute('aria-current');
            }
          }
        }

        goTo(index) {
          var pages = this.pageCount();
          if (this.usesScroll) {
            var max = this.scroller.scrollWidth - this.scroller.clientWidth;
            this.scroller.scrollTo({
              left: Math.min(index * this.step(), max),
              behavior: 'smooth',
            });
            return;
          }

          // Arrow mode: click the existing controls the right number of times.
          var diff = index - this.pageIndex;
          var control = diff > 0 ? this.nextControl : this.prevControl;
          if (!control) return;
          for (var i = 0; i < Math.abs(diff); i++) control.click();
          this.setActive(index, pages);
        }

        watchControls() {
          var self = this;
          [this.prevControl, this.nextControl].forEach(function (control) {
            if (!control) return;
            control.addEventListener('click', function () {
              var pages = self.pageCount();
              var next = self.pageIndex + (control === self.nextControl ? 1 : -1);
              self.setActive(Math.min(pages - 1, Math.max(0, next)), pages);
            });
          });
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(
            function () {
              this.ticking = false;
              var pages = this.pageCount();
              this.setActive(this.currentIndex(pages), pages);
            }.bind(this)
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["signup-sign-up"] && !Shopify.designMode) return;
  try {
    const SIGNUP_ACCESS_COOKIE = 'signup_access';
  const SIGNUP_SUBSCRIBED_COOKIE = 'signup_subscribed';
  const SIGNUP_SUBSCRIBED_EMAIL_COOKIE = 'signup_subscribed_email';
  const SIGNUP_ACCESS_TTL_DAYS = 14;
  const SIGNUP_SUBSCRIBED_TTL_DAYS = 90;
  const SIGNUP_DIALOG_CLOSE_TIMEOUT_MS = 1000;

  function signupSetCookie(name, value, days) {
    const maxAge = days * 24 * 60 * 60;
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
  }

  function signupGetCookie(name) {
    const prefix = `${name}=`;
    const cookies = document.cookie.split('; ');

    for (const cookie of cookies) {
      if (cookie.startsWith(prefix)) return decodeURIComponent(cookie.slice(prefix.length));
    }

    return null;
  }

  class SignupEarlyAccess extends HTMLElement {
    connectedCallback() {
      this.handleKlaviyoForm = this.handleKlaviyoForm.bind(this);
      window.addEventListener('klaviyoForms', this.handleKlaviyoForm);
      this.captureVipAccess();
      this.syncActiveForm();
      this.render();
      this.watchKlaviyoForm();
    }

    disconnectedCallback() {
      window.removeEventListener('klaviyoForms', this.handleKlaviyoForm);
      this.formObserver?.disconnect();
      clearTimeout(this.successTimer);
    }

    readConfig() {
      const early = {};
      const returning = {};
      const valid = {};
      const forms = {};

      this.querySelectorAll('[data-signup-vip]').forEach((node) => {
        const code = (node.dataset.code || '').trim();
        if (!code) return;

        const formId = (node.dataset.formId || '').trim();
        const access = node.dataset.access === 'returning' ? 'returning' : 'early_bird';

        valid[code] = true;
        if (access === 'returning') returning[code] = true;
        else early[code] = true;
        if (formId) forms[code] = formId;
      });

      return {
        param: (this.dataset.vipParam || 'vip').trim() || 'vip',
        fallbackCode: (this.dataset.fallbackCode || '').trim(),
        early,
        returning,
        valid,
        forms,
      };
    }

    getAccess() {
      return signupGetCookie(SIGNUP_ACCESS_COOKIE);
    }

    isSubscribed() {
      return signupGetCookie(SIGNUP_SUBSCRIBED_COOKIE) === '1';
    }

    captureVipAccess() {
      const config = this.readConfig();

      try {
        const url = new URL(window.location.href);
        const vip = url.searchParams.get(config.param);

        if (!vip || !config.valid[vip]) return false;

        signupSetCookie(SIGNUP_ACCESS_COOKIE, vip, SIGNUP_ACCESS_TTL_DAYS);
        url.searchParams.delete(config.param);

        const query = url.searchParams.toString();
        const cleanUrl = url.pathname + (query ? `?${query}` : '') + url.hash;
        window.history.replaceState(window.history.state, '', cleanUrl);
        return true;
      } catch (error) {
        return false;
      }
    }

    markSubscribed(email) {
      const config = this.readConfig();
      const currentAccess = this.getAccess();

      signupSetCookie(SIGNUP_SUBSCRIBED_COOKIE, '1', SIGNUP_SUBSCRIBED_TTL_DAYS);

      if (!config.early[currentAccess] && !config.returning[currentAccess]) {
        if (config.fallbackCode) {
          signupSetCookie(SIGNUP_ACCESS_COOKIE, config.fallbackCode, SIGNUP_ACCESS_TTL_DAYS);
        }
      } else if (config.early[currentAccess]) {
        signupSetCookie(SIGNUP_ACCESS_COOKIE, currentAccess, SIGNUP_ACCESS_TTL_DAYS);
      }

      if (email) signupSetCookie(SIGNUP_SUBSCRIBED_EMAIL_COOKIE, email, SIGNUP_SUBSCRIBED_TTL_DAYS);
    }

    canPurchase(phase) {
      const config = this.readConfig();
      const access = this.getAccess();
      const subscribed = this.isSubscribed();

      if (phase === 'public') return true;
      if (phase === 'returning') return (config.early[access] && subscribed) || !!config.returning[access];
      if (phase === 'earlybird') return !!(config.early[access] && subscribed);

      return false;
    }

    getSignupFormKey() {
      const config = this.readConfig();
      const access = this.getAccess();

      if (access && config.forms[access]) return access;

      return 'default';
    }

    getActiveSlot() {
      const formKey = this.getSignupFormKey();
      const slots = this.querySelectorAll('[data-signup-form-slot]');
      let fallback = null;

      for (const slot of slots) {
        const key = slot.getAttribute('data-signup-form-slot');
        if (key === 'default') fallback = slot;
        if (key === formKey) return slot;
      }

      return fallback;
    }

    getActiveFormId() {
      return this.getActiveSlot()?.getAttribute('data-form-id') || '';
    }

    syncActiveForm() {
      const activeSlot = this.getActiveSlot();

      this.querySelectorAll('[data-signup-form-slot]').forEach((slot) => {
        slot.hidden = slot !== activeSlot;
      });

      this.dataset.activeFormKey = activeSlot?.getAttribute('data-signup-form-slot') || 'default';
      this.dataset.formId = this.getActiveFormId();
    }

    watchKlaviyoForm() {
      const signup = this.querySelector('[data-signup-signup]');
      if (!signup) return;

      const syncLoading = () => {
        const activeSlot = this.querySelector('[data-signup-form-slot]:not([hidden])');
        const formRoot = activeSlot?.querySelector('[data-signup-klaviyo-form]');
        if (!formRoot) return;

        const hasForm = formRoot.childElementCount > 0 || formRoot.textContent.trim().length > 0;
        if (hasForm) signup.removeAttribute('data-loading');
        else signup.setAttribute('data-loading', '');
      };

      syncLoading();
      this.formObserver = new MutationObserver(syncLoading);
      this.formObserver.observe(signup, { childList: true, subtree: true, characterData: true });
    }

    getDialog() {
      return this.querySelector('dialog[ref="dialog"]');
    }

    releaseScrollLock() {
      const body = document.body;
      if (body.style.position !== 'fixed') return;

      const top = parseInt(body.style.top, 10) || 0;
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      document.documentElement.removeAttribute('scroll-lock');
      window.scrollTo(0, -top);
    }

    // Close the modal dialog properly before hiding its parent.
    // Hiding the CTA while the dialog is still open leaves the page inert
    // (top layer + backdrop + scroll-lock), so no clicks work.
    closeSignupDialog() {
      const dialog = this.getDialog();
      if (!dialog || !dialog.open) return Promise.resolve();

      if (this.closingPromise) return this.closingPromise;

      this.closingPromise = new Promise((resolve) => {
        let done = false;

        const finish = () => {
          if (done) return;
          done = true;

          if (dialog.open) dialog.close();
          dialog.classList.remove('dialog-closing');

          // Release the theme scroll lock if it was left on the body.
          if (!document.querySelector('dialog[open][scroll-lock]')) {
            this.releaseScrollLock();
          }

          this.closingPromise = null;
          resolve();
        };

        dialog.addEventListener('close', finish, { once: true });

        const component = dialog.closest('dialog-component');

        try {
          if (typeof component?.closeDialog === 'function') {
            component.closeDialog();
          } else {
            dialog.close();
          }
        } catch (error) {
          finish();
        }

        setTimeout(finish, SIGNUP_DIALOG_CLOSE_TIMEOUT_MS);
      });

      return this.closingPromise;
    }

    handleKlaviyoForm(event) {
      const { type, formId } = event.detail || {};
      if (formId !== this.getActiveFormId()) return;

      if (type === 'embedOpen' || type === 'open') {
        this.querySelector('[data-signup-signup]')?.removeAttribute('data-loading');
      }

      if (type !== 'submit') return;

      this.markSubscribed(event.detail.metaData?.$email);

      // Give the Klaviyo success message a moment, then close and switch to purchase.
      const delay = parseInt(this.dataset.successDelay, 10);
      clearTimeout(this.successTimer);
      this.successTimer = setTimeout(
        () => {
          this.closeSignupDialog().then(() => this.render());
        },
        Number.isFinite(delay) && delay >= 0 ? delay : 1500
      );
    }

    render() {
      const showPurchase = this.canPurchase(this.dataset.phase);
      const cta = this.querySelector('[data-signup-cta]');
      const purchase = this.querySelector('[data-signup-purchase]');
      const dialog = this.getDialog();

      this.syncActiveForm();

      // Never hide the CTA while its modal dialog is still open.
      if (showPurchase && dialog?.open) {
        this.closeSignupDialog().then(() => this.render());
        return;
      }

      if (cta) cta.hidden = showPurchase;
      if (purchase) purchase.hidden = !showPurchase;

      this.dataset.accessState = showPurchase ? 'purchase' : 'signup';
    }
  }

  if (!customElements.get('signup-early-access')) {
    customElements.define('signup-early-access', SignupEarlyAccess);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["site-tweaks"] && !Shopify.designMode) return;
  try {
    /* FAQ (faq_tECmLE): capitalise the first letter of every question
     row and answer paragraph. */
  (function () {
    function capFirst(el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.textContent.trim()) {
          node.textContent = node.textContent.replace(/^(\s*)(\S)/, function (m, ws, ch) {
            return ws + ch.toUpperCase();
          });
          return;
        }
      }
    }

    function run() {
      var faq = document.querySelector('[id$="__faq_tECmLE"]');
      if (!faq) return;
      faq.querySelectorAll('summary, button, h3, h4, .h3, .h4, p').forEach(capFirst);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["testimonial-video-card"] && !Shopify.designMode) return;
  try {
    // Self-contained playback controller. The block carries its own behaviour so
  // it works in any section, with no JS required from the host section.
  (function () {
    if (window.tvCardPlayback) return;
    window.tvCardPlayback = true;

    // Only pause sibling videos within the same carousel/section, never the
    // whole page, so two separate sections don't fight over playback.
    function scopeOf(media) {
      return media.closest('.tv-container') || media.closest('.shopify-section') || document;
    }

    function bind(media) {
      // Shared guard: older copies of the section script use this same flag, so
      // whichever runs first binds and the other skips instead of double-binding.
      if (media.dataset.tvVideo) return;
      var video = media.querySelector('video');
      if (!video) return;
      media.dataset.tvVideo = '1';

      var usesNativeControls = media.classList.contains('tv-card__media--controls');

      function setUI() {
        media.classList.toggle('is-playing', !video.paused && !video.ended);
        media.classList.toggle('is-muted', video.muted);
      }

      function pauseOthers() {
        scopeOf(media).querySelectorAll('.tv-card__media video').forEach(function (other) {
          if (other !== video && !other.paused) other.pause();
        });
      }

      // Play with sound; if the browser blocks that, retry muted so a tap always
      // does something visible.
      function tryPlay(withSound) {
        if (withSound) video.muted = false;
        var played = video.play();
        if (played && played.catch) {
          played.catch(function () {
            video.muted = true;
            var retry = video.play();
            if (retry && retry.catch) retry.catch(function () {});
            setUI();
          });
        }
      }

      function toggle() {
        if (video.paused) {
          pauseOthers();
          tryPlay(true);
        } else {
          video.pause();
        }
        setUI();
      }

      video.addEventListener('play', setUI);
      video.addEventListener('pause', setUI);
      video.addEventListener('volumechange', setUI);

      // With native controls the browser owns play/pause and volume; adding our
      // own click handler on top would fight it on every tap.
      if (!usesNativeControls) {
        media.addEventListener('click', function (event) {
          if (event.target.closest('.tv-card__label') || event.target.closest('.tv-card__sound')) return;
          event.preventDefault();
          toggle();
        });

        // pointerup rather than click: immune to the theme's click delegation
        // and to a carousel swallowing the click after a drag.
        var soundButton = media.querySelector('.tv-card__sound');
        if (soundButton) {
          soundButton.addEventListener('pointerup', function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (video.muted) {
              if (video.paused) {
                pauseOthers();
                tryPlay(true);
              } else {
                video.muted = false;
              }
            } else {
              video.muted = true;
            }
            setUI();
          });
        }
      }

      if (media.dataset.autoplay === 'true') autoplay(media, video);
      setUI();
    }

    function autoplay(media, video) {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      video.muted = true;
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // A viewer who unmuted this card keeps their choice: autoplay is
              // only allowed while muted, so an unmuted card is left alone.
              if (video.muted && video.paused) {
                var played = video.play();
                if (played && played.catch) played.catch(function () {});
              }
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.5 }
      ).observe(media);
    }

    function init() {
      document.querySelectorAll('.tv-card__media').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Theme editor re-renders sections and can move blocks between them.
    document.addEventListener('shopify:section:load', function () {
      init();
      setTimeout(init, 300);
    });
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
